/* src/app/modules/finanzas/creditos/creditos.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
ul,
li {
  list-style-type: none;
}
li {
  margin: auto 10px;
}
th,
td {
  padding: 5px;
  vertical-align: top;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 auto;
}
.cr-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.cr-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.cr-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cr-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.cr-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.cr-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.cr-btn-save {
  margin-left: auto;
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.cr-btn-save:hover:not([disabled]) {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.cr-body {
  padding: 14px 20px;
  flex: 1;
}
.cr-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
}
@media (max-width: 900px) {
  .cr-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .cr-body {
    padding: 10px 12px;
  }
  .cr-header {
    padding: 10px 14px;
  }
}
.cr-section {
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius-lg, 12px);
  overflow: hidden;
  box-shadow: var(--cf-shadow-sm, 0 1px 3px rgba(0,0,0,0.08));
  margin-bottom: 16px;
}
.cr-section:last-child {
  margin-bottom: 0;
}
.cr-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--cf-bg, #f4f6f8);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cf-text, #1a1d23);
}
.cr-section__head mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: var(--cf-brand, #e3fd64);
  flex-shrink: 0;
}
.cr-section__body {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.cr-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}
@media (max-width: 500px) {
  .cr-two-col {
    grid-template-columns: 1fr;
  }
}
.cr-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 18px;
}
.cr-loading__icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: var(--cf-brand, #e3fd64);
  opacity: 0.6;
}
.cr-loading__text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--cf-text-muted, #6b7280);
}
::ng-deep .cr-page .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .cr-page .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dlg-hdr__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dlg-hdr__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #e3fd64;
}
.dlg-hdr__icon-wrap--red {
  background: rgba(220, 38, 38, .12);
}
.dlg-hdr__icon-wrap--red mat-icon {
  color: #dc2626;
}
.dlg-hdr__title > div > span {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
}
.dlg-hdr__sub {
  display: block;
  font-size: 12px;
  color: #6b7280;
}
.dlg-hdr__close {
  color: #6b7280;
  flex-shrink: 0;
}
.dlg-body {
  padding: 24px 24px 8px !important;
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.dlg-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.dlg-btn-delete {
  background-color: #dc2626 !important;
  color: #fff !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.delete-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: #fff8f8;
  border: 1px solid #fecaca;
  border-radius: 8px;
}
.delete-info mat-icon {
  color: #dc2626;
  flex-shrink: 0;
  margin-top: 2px;
}
.delete-info__text {
  font-size: 14px;
  color: #1a1d23;
  line-height: 1.5;
}
.delete-info--success {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.delete-info--success mat-icon {
  color: #16a34a;
}
.delete-info--info {
  background: #f4f6f8;
  border-color: #e5e7eb;
}
.delete-info--info mat-icon {
  color: #6b7280;
}
.dlg-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 8px 0 20px;
  text-align: center;
}
.dlg-upload__label {
  font-size: 13px;
  color: #6b7280;
}
.dlg-upload__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
  transition: border-color .15s, background .15s;
}
.dlg-upload__btn:hover {
  border-color: #e3fd64;
  background: #f9ffe0;
}
.dlg-upload__btn input[type=file] {
  display: none;
}
/*# sourceMappingURL=creditos.component.css.map */
